import { RouterView } from "vue-router";
// import { warehousingRouting }  from './warehousing/warehousing.routing'
// import { retreatRouting } from './retreat/retreat.routing'
// import { maintainInfoRouting } from './maintainInfo/maintainInfo.routing'
// import { reductionRouting } from './reduction/reduction.routing'
export const AppStoreRouting = {
  path: "/appStore",
  name: "appStore",
  component: RouterView,
  meta: { title: "应用商城", icon: "asset" },
  children: [
    {
      path: "/appStore/list",
      name: "appStore-list",
      meta: { title: "应用商城" },
      component: () =>
        import(/* webpackChunkName: "warehousing-list" */ "@/views/app-store/app-store-list/index.vue"),
    },
    // ...warehousingRouting,
    // ...retreatRouting,
    // ...maintainInfoRouting,
    // ...reductionRouting
  ],
};
